import { FormBuilder } from '@angular/forms';
import {
    AbstractWidgetComponent,
    FilterField,
    getFieldFromArray,
    isNotEmpty
} from '../../../utils/util';
import { DataelementApi, EntityApi, LoopBackAuth } from '../../../sdk';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { PushNotificationsService, NotificationsService } from 'angular2-notifications';
import { PlatformApp } from '../../../services/app.service';
@Component({
    selector: 'linechart-widget',
    templateUrl: './linechart.component.html',
    styleUrls: ['./linechart.component.scss']
})

export class LineChartComponent extends AbstractWidgetComponent implements OnInit, OnDestroy {
    id = 'linechart' + Math.floor((Math.random() * 1000000000000) + 1);
    @Input() title = '';
    ddd = false;
    @Input() widget: any;
    _dataelementid = '';
    _comparefields = [''];
    _basefield = '';
    notifyOptions = PlatformApp.getNotificationOptions();
    constructor(_dataelementApi: DataelementApi, fb: FormBuilder,
        private _NotificationsService: NotificationsService,
        _loopBackAuth: LoopBackAuth, _entityApi: EntityApi) {
        super(_dataelementApi, fb, _loopBackAuth, _entityApi);
    }

    ngOnInit() {
        if (this.widget) {
            this._dataelementid = this.widget.dataelement;
            this.ddd = this.widget.ddd ? Boolean(this.widget.ddd) : this.ddd;
            this.autorefresh = this.widget.autorefresh ? Boolean(this.widget.autorefresh) : this.autorefresh;
            this._basefield = this.widget.basefield;
            this._comparefields = isNotEmpty(this.widget.comparefields) ? this.widget.comparefields : [this.widget.comparefield];
            if (isNotEmpty(this.widget.filterfields)) {
                this.filter_fields = _.cloneDeep(this.widget.filterfields);
            }
            this.title = this.widget.title;
        }
        this.options = this.createChartConfig();
        this.setChartConfig();
    }

    createChartConfig(dataelement?) {
        let options = {
            'type': 'serial',
            'theme': 'light',
            'marginRight': 10,
            'marginLeft': 10,
            'autoMarginOffset': 20,
            'dataProvider': {},
            'valueAxes': [{
                'id': 'v1',
                'axisAlpha': 0.2,
                'dashLength': 1,
                'position': 'left',
                'ignoreAxisWidth': true
            }],
            'valueScrollbar': {
                'oppositeAxis': false,
                'offset': 70,
                'scrollbarHeight': 10
            },
            'balloon': {
                'borderThickness': 1,
                'shadowAlpha': 0
            },
            'mouseWheelZoomEnabled': true,
            'graphs': [],
            'chartScrollbar': {
                'graph': 'g1',
                'oppositeAxis': false,
                'offset': 30,
                'scrollbarHeight': 30,
                'backgroundAlpha': 0,
                'selectedBackgroundAlpha': 0.1,
                'selectedBackgroundColor': '#888888',
                'graphFillAlpha': 0,
                'graphLineAlpha': 0.5,
                'selectedGraphFillAlpha': 0,
                'selectedGraphLineAlpha': 1,
                'autoGridCount': true,
                'color': '#AAAAAA'
            },
            'legend': {
                'enabled': true,
                'useGraphSettings': true
            },
            /**'titles': [
                {
                    'id': 'Title-1',
                    'size': 15,
                    'text': this.title
                }
            ],*/
            'chartCursor': {
                'pan': true,
                'valueLineEnabled': true,
                'valueLineBalloonEnabled': true,
                'cursorAlpha': 1,
                'cursorColor': '#258cbb',
                'limitToGraph': 'g1',
                'valueLineAlpha': 0.2,
                'valueZoomable': true
            },
            'categoryField': '',
            'categoryAxis': {
                'parseDates': true,
                'axisColor': '#DADADA',
                'dashLength': 1,
                'minorGridEnabled': true,
                'equalSpacing': true
            }
        };
        if (dataelement) {
            options.dataProvider = dataelement.data;
            options.categoryField = this._basefield;
            let index = 1;
            this._comparefields.forEach(cf => {
                let field = getFieldFromArray(dataelement.fields, cf);
                if (field) {
                    let graph = {
                        'id': 'g' + index,
                        'balloon': {
                            'drop': true,
                            'adjustBorderColor': false,
                            'color': '#ffffff'
                        },
                        'balloonText': '[[value]]',
                        'bullet': 'round',
                        'bulletSize': 5,
                        'bulletBorderAlpha': 1,
                        'bulletColor': '#FFFFFF',
                        'hideBulletsCount': 50,
                        'title': field.label,
                        'valueField': field.name,
                        'useLineColorForBulletBorder': true
                    };
                    if (field.unit) {
                        graph.balloonText += ' ' + field.unit;
                    }
                    options.graphs.push(graph);
                }
            });

        }
        //console.log('options:-', JSON.stringify(options));
        return options;
    }

    ngOnDestroy() {
        clearInterval(this._timer);
    }

    notify(type, title?, content?, options?) {
        if (!options) options = PlatformApp.getNotificationOptions();
        if (!options.id) options.id = type + '-' + title + '_' + content;
        switch (type) {
            case 'success': this._NotificationsService.success(title, content, options); break;
            case 'alert': this._NotificationsService.alert(title, content, options); break;
            case 'error': this._NotificationsService.error(title, content, options); break;
            case 'info': this._NotificationsService.info(title, content, options); break;
            case 'bare': this._NotificationsService.bare(title, content, options); break;
            default: this._NotificationsService.info(title, content, options);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/widgets/linechart/linechart.component.ts